import React from 'react';
// Import the main orchestrator component from the sub-directory
import ProjectDetailIndex from './ProjectDetail/index'; // Adjust the path if your structure differs slightly

// This component simply acts as a clean entry point
const ProjectDetail = (props) => {
  // Pass down any props received by this wrapper
  return <ProjectDetailIndex {...props} />;
};

export default ProjectDetail;